module.exports = __webpack_public_path__ + "static/media/رحلات إلى مونترو.f18f60fc.jpg";